import { toUrlParameters } from './util';
export class UserRemoteRepository {
    constructor(fetcher, contextId) {
        this.fetcher = fetcher;
        this.contextId = contextId;
    }
    async getCurrentAuthUser() {
        return await this.fetcher.fetchGetJson(`${UserRemoteRepository.USERS_PATH}/me`);
    }
    async fetchUsers() {
        const params = {
            contextId: this.contextId,
            active: true
        };
        const responses = await this.fetcher.fetchGetJson(`${UserRemoteRepository.USERS_PATH}?${toUrlParameters(params)}`);
        return responses.map(response => UserRemoteRepository.mapResponseToUser(response));
    }
    async saveUser(userSaveRequest) {
        if (userSaveRequest.password !== null && userSaveRequest.password.length === 0) {
            userSaveRequest.password = null;
        }
        if (userSaveRequest.currentPassword !== null && userSaveRequest.currentPassword.length === 0) {
            userSaveRequest.currentPassword = null;
        }
        const saveRequest = Object.assign({ contextId: this.contextId }, userSaveRequest);
        return await this.fetcher.fetchPostJson(UserRemoteRepository.USERS_PATH, saveRequest);
    }
    async saveUserPassword(userPasswordSaveRequest) {
        return await this.fetcher.fetchPostJson(`${UserRemoteRepository.USERS_PATH}/password`, userPasswordSaveRequest);
    }
    async unblockUser(userId) {
        return await this.fetcher.fetchPostJson(`${UserRemoteRepository.USERS_PATH}/${userId}/unblock`);
    }
    async deleteUser(userId) {
        return await this.fetcher.fetchDeleteJson(`${UserRemoteRepository.USERS_PATH}/${userId}`);
    }
    static mapResponseToUser(response) {
        return response;
    }
}
UserRemoteRepository.USERS_PATH = '/api/users';
